<template>
  <div class="request">
    <el-card>
      <img class="logo" src="/logo.png" />

      <h2>X-CUBE</h2>
      <h5>REQUEST LOGIN LINK</h5>

      <el-form class="request-form" :model="model" :rules="rules" ref="form"
        @submit.native.prevent="requestPasswordReset">
        <el-form-item prop="email">
          <el-input v-model="model.email" placeholder="E-mail" prefix-icon="fas fa-user"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button :loading="loading" :disabled="model.email.length === 0" class="request-button" type="primary"
            native-type="submit" block>
            Request Link
          </el-button>
        </el-form-item>
        <div class="action-links">
          <router-link to="/login">
            Back to login
          </router-link>
        </div>
      </el-form>
    </el-card>
  </div>
</template>
<script setup>
import { Message } from "element-ui";
import { ref, reactive } from "vue";
import { useRouter } from "vue-router/composables";
import { requestLoginLinkOnServer } from "../../api/rest";

const router = useRouter();
const form = ref(null);
const loading = ref(false);
const rules = reactive({
  email: [
    {
      required: true,
      message: "Please enter your email.",
      trigger: "blur"
    }
  ],
});

const model = ref({ email: "" });


const requestPasswordReset = async () => {
  const valid = await form.value.validate();
  if (!valid) {
    return;
  }

  const email = model.value.email.trim();

  try {
    loading.value = true;
    await requestLoginLinkOnServer(email);
    Message.success("Login link requested successfully.");
    router.push("request");
  } catch (error) {
    let message = "Failed to request login link.";
    if (error instanceof Error && error.message) {
      message += ` ${error.message}.`;
    }
    Message.error(message);
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped lang="scss">
.logo {
  height: 64px;
}

.request {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.request-button {
  width: 100%;
  margin-top: 40px;
}

.request-form {
  width: 290px;
}

.forgot-password {
  margin-top: 10px;
}
</style>
<style lang="scss">
$teal: rgb(0, 124, 137);

.el-button--primary {
  background: $teal;
  border-color: $teal;

  &:hover,
  &.active,
  &:focus {
    background: lighten($teal, 7);
    border-color: lighten($teal, 7);
  }
}

.request .el-input__inner:hover {
  border-color: $teal;
}

.request .el-input__prefix {
  background: rgb(238, 237, 234);
  left: 0;
  height: calc(100% - 2px);
  left: 1px;
  top: 1px;
  border-radius: 3px;

  .el-input__icon {
    width: 30px;
  }
}

.request .el-input input {
  padding-left: 35px;
  font: inherit;
}

.request .el-card {
  padding-top: 0;
  padding-bottom: 30px;
}

h2 {
  // font-family: "Open Sans";
  letter-spacing: 1px;
  font-family: "Bungee", display;
  padding-bottom: 20px;
}

a {
  color: $teal;
  text-decoration: none;

  &:hover,
  &:active,
  &:focus {
    color: lighten($teal, 7);
  }
}

.request .el-card {
  width: 340px;
  display: flex;
  justify-content: center;
}

.action-links {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
